export default "/static/assets/2a6230ec4a2239f5.png"